import React, {
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
} from 'react';
import classNames from 'classnames';

import { WithChildren } from 'common/types';

import { OptionType } from 'common/components/Select/types';
import CachedImage from 'common/components/CachedImage';
import styles from './styles.module.scss';

export interface IRadioButtonProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string,
  label?: string,
  image?: string,
  option: OptionType,
}

const RadioButton = React.memo(forwardRef(({
  name,
  label,
  image,
  option,
  className,
  children,
  ...props
}: WithChildren<IRadioButtonProps>, ref: ForwardedRef<HTMLInputElement>) => (
  <div className={classNames(styles.wrapper, 'danfloss-components-RadioButton__wrapper', className)}>
    <label
      htmlFor={option.id}
    >
      {image && (
        <CachedImage
          className={classNames(styles.image, 'danfloss-components-RadioButton__image')}
          src={image}
          alt={name}
        />
      )}
    </label>
    <input
      {...props}
      ref={ref}
      type="radio"
      id={`${props.value}`}
      name={name}
      className={classNames(styles.input, 'danfloss-components-RadioButton__input')}
      tabIndex={0}
    />
    <label
      htmlFor={option.id}
      className={classNames(styles.radioButton, 'danfloss-components-RadioButton__label')}
    >
      {option.title}
    </label>
    <div className={classNames(styles.description)}>
      {(option.attributes as any)?.description}
    </div>
  </div>
)));

RadioButton.displayName = 'AccessoriesRadioButton';

// @ts-ignore
export default RadioButton;
